import { useState, useContext, useEffect } from "react";
import { FaEdit, FaPlusCircle, FaTrashAlt, FaCalendarAlt, FaClipboardList, FaEnvelope, FaBook, FaShieldAlt, FaCalculator, FaChartLine, FaBalanceScale, FaFileContract, FaStar } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import Dialogs from "components/ui/dialogs/dialogs";
import { AuthContext } from "components/auth/auth-provider";
import Emoji from "components/ui/emoji/emoji";
import {
  createStyledButton,
} from "components/ui/controls/button/button-styles";
import "./ListeAudits.css";
import "./AccesEtude.css";

const ListeAudits = (props) => {
  const context = useContext(AppContext);
  const [modalMakoFormation, setmodalMakoFormation] = useState(false);
  const authContext = useContext(AuthContext);

  // Fonction helper pour récupérer les informations du client depuis la liste des clients
  const getClientInfo = (dossier) => {
    // Si les informations sont directement disponibles dans le dossier
    if ( context.state.Civilite &&  context.state.Nom &&  context.state.Prenom) {
      return {
        civilite: context.state.Civilite,
        nom:  context.state.Nom,
        prenom:  context.state.Prenom,
        found: true
      };
    }
    console.log('Dossier:', dossier, 'ListeClient:', context.state.ListeClient);
    // Sinon, chercher dans la liste des clients avec l'IdClient
    if (dossier.IdClient && context.state.ListeClient) {
      const client = context.state.ListeClient.find(c => c.IdClient === dossier.IdClient);
      if (client) {
        return {
          civilite: client.Civilite,
          nom: client.Nom,
          prenom: client.Prenom,
          found: true
        };
      } else {
        // Debug : log si le client n'est pas trouvé
        console.warn('Client non trouvé pour IdClient', dossier.IdClient, context.state.ListeClient);
      }
    }
    // Fallback: informations manquantes
    return {
      civilite: '',
      nom: '',
      prenom: 'Client inconnu',
      found: false
    };
  };
  const [etude, setEtude] = useState("");
  useEffect(() => {
    context.handleListeDossier();
  }, []);

  // S'assurer que l'état AccesEtude est cohérent au montage du composant
  useEffect(() => {
    // Si on arrive sur la page des audits sans paramètre AccesEtude spécifique,
    // s'assurer qu'on affiche bien la page principale
    if (!props.AccesEtude || props.AccesEtude === "") {
      // Optionnel: forcer la réinitialisation si nécessaire
      if (props.SetAccessEtude) {
        props.SetAccessEtude("");
      }
    }
  }, [props.AccesEtude, props.SetAccessEtude]);

  return (
    <>
      <Column fill>
        {props.AccesEtude === "" && (
          <>
            {/* Header avec titre et sous-titre - Version avec cadre blanc */}
            <CardBox className="header-section">
              <Column fill>
                <div className="header-content">
                  <h1 className="main-title">
                    Votre gamme logicielle
                  </h1>
                  <p className="main-subtitle">
                    Choisissez votre simulateur pour accompagner vos clients
                  </p>
                </div>
              </Column>
            </CardBox>

            {/* Pack Essentiel avec design moderne */}
            <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon green-theme">
                    <Emoji symbol="⭐" />
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Essentiel
                    </h1>
                    <p className="pack-description">
                      Les outils indispensables pour optimiser la rémunération et la protection sociale de vos clients
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  {/* Audit Complet */}
                  <div className="audit-pack-card violet-theme" 
                  onClick={() => {
                    props.SetAccessEtude("Audit complet");
                    setEtude("audit complet");
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="🎯" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Complet
                    </h3>
                    <p className="audit-pack-card-description">
                      Analyse complète et approfondie
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Retraite */}
                  <div className="audit-pack-card blue-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit retraite");
                    setEtude("audit de retraite");
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="🌅" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Retraite
                    </h3>
                    <p className="audit-pack-card-description">
                      Optimisation retraite
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Prévoyance */}
                  <div className="audit-pack-card green-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit prévoyance");
                    setEtude("audit de prévoyance");
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="🛡️" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Prévoyance
                    </h3>
                    <p className="audit-pack-card-description">
                      Protection sociale optimale
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Rémunération */}
                  <div className="audit-pack-card red-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit rémunération");
                    setEtude("audit de rémunération");
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="⚖️" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Rémunération
                    </h3>
                    <p className="audit-pack-card-description">
                      Équilibre salarial optimal
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>
                </Row>
              </Column>
            </CardBox>

            {/* Pack Expert avec design moderne */}
            <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon red-theme">
                    <Emoji symbol="🎯" />
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Expert
                    </h1>
                    <p className="pack-description">
                      Outils avancés pour approfondir votre expertise
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  {/* Calculatrice AGIRC ARRCO */}
                  <div className="audit-pack-card blue-theme"
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Calculatrice AGIRC ARRCO");
                      setEtude("calculatrice AGIRC ARRCO");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="🧮" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Calculatrice AGIRC ARRCO
                    </h3>
                    <p className="audit-pack-card-description">
                      Calcul des points retraite
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Déclaration PER */}
                  <div className="audit-pack-card violet-theme"
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Déclaration PER");
                      setEtude("déclaration PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="📋" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Déclaration PER
                    </h3>
                    <p className="audit-pack-card-description">
                      Gestion déclarative PER
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Correction PER */}
                  <div className="audit-pack-card red-theme"
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Correction plafond PER");
                      setEtude("correction plafond PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="🔧" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Correction PER
                    </h3>
                    <p className="audit-pack-card-description">
                      Rectification des plafonds
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Stratégie PER */}
                  <div className="audit-pack-card green-theme"
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Stratégie PER");
                      setEtude("stratégie PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="📊" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Stratégie PER
                    </h3>
                    <p className="audit-pack-card-description">
                      Optimisation stratégique
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Droits de succession */}
                  <div className="audit-pack-card orange-theme"
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Droits de succession");
                      setEtude("droits de succession");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      <Emoji symbol="⚖️" />
                    </div>
                    <h3 className="audit-pack-card-title">
                      Droits de succession
                    </h3>
                    <p className="audit-pack-card-description">
                      Calcul des droits successoraux
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>
                </Row>
              </Column>
            </CardBox>
            {/* Pack Expert avec design moderne */}
            {/* <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon red-theme">
                    🎯
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Expert
                    </h1>
                    <p className="pack-description">
                      Outils avancés pour approfondir votre expertise
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'blue-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Correction de carrière");
                      setEtude("correction de carrière");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "💼" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Correction de carrière" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Révision du parcours professionnel" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                </Row>
              </Column>
            </CardBox> */}
          </>
        )}
        {props.AccesEtude !== "" && (
          <>
            <CardBox>
              <Column fill>
                <Row center>
                  <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
                    <Button
                      {...createStyledButton("primary")}
                      onClick={() => {
                        context.handleNewSimulation(props.AccesEtude);
                      }}
                    >
                      <FaPlusCircle style={{ marginRight: "8px" }} />
                      Créer une nouvelle étude
                    </Button>
                  </Column>
                </Row>
              </Column>
            </CardBox>

            <CardBox>
              <Column fill>
                <Row>
                  <Column scroll fill>
                    <div className="studies-scroll">
                      <div className="studies-header">
                        <FaClipboardList className="studies-header-icon" />
                        <h3 className="studies-header-title">
                          {props.AccesEtude} (
                          {context.state.ListeDossier?.filter(Infos => Infos.TypeSimulation === props.AccesEtude).length || 0}
                          )
                        </h3>
                      </div>
                    {context.state.ListeDossier?.filter(
                      Infos => Infos.TypeSimulation === props.AccesEtude
                    ).length === 0 ? (
                      <div className="studies-empty">
                        <FaClipboardList className="studies-empty-icon" />
                        <p className="studies-empty-text">Aucune étude trouvée</p>
                      </div>
                    ) : (
                      context.state.ListeDossier?.filter(
                        Infos => Infos.TypeSimulation === props.AccesEtude
                      ).map((Infos, index) => {
                        const clientInfo = getClientInfo(Infos);
                        return (
                        <div className="study-card" key={"DOSSIER" + index}>
                          <div className="study-card-main">
                            <div className="study-card-info">
                              <div className="study-card-avatar">
                                {Infos.TypeSimulation?.[0] || "?"}
                              </div>
                              <div className="study-card-details">
                                <div className="study-card-row">
                                  <h4 className="study-card-title">{Infos.InfosDossier.LibelleDossier}</h4>
                                </div>
                                <div className="study-card-client">
                                  {clientInfo.found ? (
                                    `${clientInfo.civilite} ${clientInfo.nom} ${clientInfo.prenom}`
                                  ) : (
                                    <span style={{color:'#ef4444'}}>Client inconnu</span>
                                  )}
                                </div>
                                <div className="study-card-type">
                                  {Infos.TypeSimulation}
                                </div>
                                <div className="study-card-date">
                                  <FaCalendarAlt style={{ fontSize: "11px", color: "#666" }} />
                                  <span>Modifié le {Infos.DateAdd} à {Infos.HeureAdd}</span>
                                </div>
                              </div>
                            </div>
                            <div className="study-card-actions">
                              <Button
                                onClick={() => {
                                  context.handleOpenDossier(Infos.IdDossier);
                                }}
                                icon
                                {...createStyledButton("card-action", "cardEdit")}
                              >
                                <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                              </Button>
                              <Button
                                onClick={() => {
                                  Dialogs.confirm("Vous êtes sur le point de supprimer ce dossier. Voulez-vous continuer ?", "Suppression du dossier", () => {
                                    context.handleDeleteDossier(Infos.IdDossier);
                                  });
                                }}
                                icon
                                {...createStyledButton("card-action", "delete")}
                              >
                                <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                              </Button>
                            </div>
                          </div>
                        </div>
                        );
                      })
                    )}
                    </div>
                  </Column>
                </Row>
              </Column>
            </CardBox>
          </>
        )}
        <Modal
          width="680px"
          height="auto"
          title="Pack expert"
          visible={modalMakoFormation}
          onClose={() => {
            setmodalMakoFormation(false);
          }}
        >
          <div className="pack-expert-modal">
            <div className="pack-expert-access-banner">
              <div className="pack-expert-access-icon">
                <FaStar />
              </div>
              <div>
                <p className="pack-expert-access-title">Option réservée aux abonnés Pack Expert</p>
                <p className="pack-expert-access-sub">
                  Pour souscrire, contactez-nous :{" "}
                  <a href="mailto:contact@mako-remexpert.com" className="pack-expert-email">
                    <FaEnvelope style={{ marginRight: 4, verticalAlign: "middle" }} />
                    contact@mako-remexpert.com
                  </a>
                </p>
              </div>
            </div>

            <p className="pack-expert-section-label">Le pack expert comprend</p>

            <div className="pack-expert-features">
              {[
                { icon: <FaBook />, color: "#667eea", label: "Guide protection sociale", desc: "150 pages de fiches pédagogiques sur la retraite et la prévoyance du chef d’entreprise." },
                { icon: <FaShieldAlt />, color: "#36D1DC", label: "Base contrats prévoyance TNS", desc: "Une trentaine de contrats analysés : délai d’attente, exclusions, garanties, barème d’invalidité…" },
                { icon: <FaCalculator />, color: "#4CAF50", label: "Calculette AGIRC ARRCO", desc: "Contrôlez et vérifiez les points retraite complémentaire acquis." },
                { icon: <FaChartLine />, color: "#FF6B35", label: "Outils plafond PER", desc: "Aide à la détermination et déclaration du plafond PER (art. 163 quatervicies du CGI)." },
                { icon: <FaChartLine />, color: "#764ba2", label: "Aide à la vente du PER", desc: "Efficacité du dispositif nette de fiscalité et de PS à l’entrée et à la sortie." },
                { icon: <FaBalanceScale />, color: "#e57373", label: "Simulateur droits de succession", desc: "Calcul et simulation des droits de succession." },
                { icon: <FaFileContract />, color: "#5B86E5", label: "Comparaison contrats prévoyance", desc: "Comparaison des conditions générales des contrats de prévoyance." },
              ].map(({ icon, color, label, desc }, i) => (
                <div key={i} className="pack-expert-feature-item">
                  <div className="pack-expert-feature-icon" style={{ background: color }}>
                    {icon}
                  </div>
                  <div className="pack-expert-feature-text">
                    <span className="pack-expert-feature-label">{label}</span>
                    <span className="pack-expert-feature-desc">{desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal>
      </Column>
    </>
  );
};

export default ListeAudits;
